import React, { useEffect, useRef } from "react";
import "./AboutCTA.css";

const AboutCTA = () => {
  const ctaRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("oglitz-cta-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (ctaRef.current) observer.observe(ctaRef.current);
  }, []);

  return (
    <section className="oglitz-about-cta" ref={ctaRef}>
      <div className="oglitz-about-cta-container">
        <span className="oglitz-about-cta-badge">
          Let’s Build Something Great
        </span>

        <h2>
          Ready to <span>Transform Your Ideas</span> into Scalable Solutions?
        </h2>

        <p>
          Partner with Oglitz Software to build secure, high-performance digital
          products backed by experienced teams and a global delivery model.
        </p>

        <div className="oglitz-about-cta-actions">
          <a href="/contact" className="oglitz-cta-primary">
            Start Your Project
          </a>

          <a href="/contact" className="oglitz-cta-secondary">
            Talk to Experts
          </a>

          {/* WhatsApp CTA */}
          <a
            href="https://wa.me/919532119007"
            target="_blank"
            rel="noopener noreferrer"
            className="oglitz-cta-whatsapp"
          >
            WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutCTA;
